// ----------------------------------------------------------------------
export function menu(theme) {
    return {
        MuiMenuItem: {
            styleOverrides: {
                root: {
                    // padding: theme.spacing(0.75, 1.5),
                    minHeight: 36,
                    fontSize: '14px',
                    fontWeight: 400,
                    borderRadius: theme.spacing(0.75),
                    // margin: theme.spacing(0.25, 0.5),
                    transition: theme.transitions.create(['background-color', 'color'], {
                        duration: theme.transitions.duration.shorter,
                    }),
                    '& .MuiListItemIcon-root': {
                        marginRight: theme.spacing(1),
                        minWidth: 'auto',
                        '& svg': {
                            fontSize: '16px',
                        }
                    },
                    '&:hover': {
                        backgroundColor: theme.palette.action.hover,
                    },
                    // Error color styling for delete items
                    '&.error-item': {
                        color: theme.palette.error.main,
                        '& .MuiListItemIcon-root svg': {
                            color: theme.palette.error.main,
                        },
                        '&:hover': {
                            backgroundColor: theme.palette.error.light + '08', // Very light error color
                        }
                    }
                }
            }
        },
        MuiMenu: {
            styleOverrides: {
                paper: {
                    // Use the dropdown shadow from custom shadows
                    boxShadow: theme.customShadows.dropdown,
                    borderRadius: 12,
                    backgroundColor: theme.palette.background.paper,
                    border: `1px solid ${theme.palette.divider}`,
                    minWidth: 140,
                    // padding: theme.spacing(0.5),
                    '& .MuiList-root': {
                        padding: 0,
                    }
                }
            }
        }
    };
}
